import { defineComponent as _defineComponent } from 'vue'
import { ExternalCompany, TtOutsetStrikeNumberReport } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { sumBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";
import { formatCount } from "@/helpers/formatCount";
import { useQuery } from "@vue/apollo-composable";
import { computed } from "vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TtOutsetStrikeStatementsModal',
  props: {
    value: { type: Boolean },
    startReleaseDate: null,
    endReleaseDate: null,
    userId: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: "input", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  startReleaseDate?: string;
  endReleaseDate?: string;
  userId: ExternalCompany["userId"];
};



const { result: ttStrikeNumberOutsetReportsResult, loading } = useQuery<{
  ttStrikeNumberOutsetReports: TtOutsetStrikeNumberReport[];
}>(queries.ttStrikeNumberOutsetReports, {
  releaseDateStart: props.startReleaseDate,
  releaseDateEnd: props.endReleaseDate,
  userId: computed(() => props.userId),
});

const { $t } = useTranslation();



const ttStrikeNumberOutsetReports = computed(() => {
  return ttStrikeNumberOutsetReportsResult.value?.ttStrikeNumberOutsetReports;
});

const processedStrikeNumberReports = computed(() => {
  return ttStrikeNumberOutsetReports.value
    ?.map((report) => {
      return {
        ...report,
        summary: {
          unit: sumBy(report.rows, (row) => row.unit),
          strikeAmount: sumBy(report.rows, (row) => row.strikeAmount),
        },
      };
    })
    .sort((a, b) => {
      return customMoment(a.releaseDate).isAfter(customMoment(b.releaseDate))
        ? -1
        : 1;
    });
});

function formatDate(date: string) {
  return customMoment(date).format("DD MMM YYYY");
}
function formatDatetime(date: string) {
  return customMoment(date).format("DD/MMM HH:mm:ss");
}

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, ttStrikeNumberOutsetReportsResult, loading, $t, emit, ttStrikeNumberOutsetReports, processedStrikeNumberReports, formatDate, formatDatetime, toggleModal, formatDollar, formatCount }
}

})